<template>
  <div class="specs">
    <ul>
      <li
        v-for="spec in product.specs"
        :key="spec.label"
      >
        <strong>{{ spec.label }}</strong><span>{{ spec.value }}</span>
      </li>
    </ul>
    <strong class="price">{{ product.price }}</strong>
  </div>
</template>
<script>
export default {
  name: 'ProductSpecs',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="stylus" scoped>
.specs {
    color: var(--inverted-text-color);
    border-radius: 10px;
    border: 1px solid var(--main-color);
    padding: 30px 20px 15px;
    ul {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-bottom: 16px;
      li {
        display: flex;
        gap: 6px;
        font-size: 14px;
        justify-content: space-between;
        border-bottom: 1px solid var(--light-color);
        padding-bottom: 10px;
        margin-top: 2px;
        &:last-child {
          border: none;
        }
        strong {
          font-weight: 600;
        }
      }
    }
    strong.price {
      font-size: 24px;
      font-weight: bold;
    }
  }
</style>
